import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import CharmLogo from '../../assets/charm-logo.png';
import { useUser } from '../../UserContext';
import { signOut } from 'aws-amplify/auth';

const RejectedVendor = () => {
    const navigate = useNavigate();
    const { userStatus, setIsSignedIn } = useUser();
    const [countdown, setCountdown] = useState(10);

    useEffect(() => {
    const timer = setInterval(() => {
        setCountdown(prevCountdown => prevCountdown - 1);
    }, 1000);

    if (countdown === 0) {
        handleLogout();
    }
    return () => clearInterval(timer);
    }, [countdown]);

    const handleLogout = async () => {
        try {
            await signOut();
            setIsSignedIn(false);
            navigate('/vendors');
        } catch (error) {
        }
    };

    // Check userStatus to see if the user is rejected or not
    useEffect(() => {
        if (userStatus !== 'REJECTED') {
            navigate('/vendors/loading');
        }
    }, []);
    
    return (
        <div className=''>
            <div className="mx-4">
                <img src={CharmLogo} alt="Charm Health" className="mb-2 w-[20rem]" />
                <div className=''>Your account has been REJECTED. Please contact support if you think this is a mistake. </div>
                <div>
                    You will be logged out automatically in {countdown} seconds.
                    <button onClick={handleLogout} className="underline text-blue-500 hover:text-blue-700">
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
}

export default RejectedVendor;
